<template>
  <div id="app">
    <homeT msg="Welcome to Your Vue.js App"/>
  </div>
</template>

<script>
import homeT from './components/homeT.vue'

export default {
  name: 'App',
  components: {
    homeT
  },
  mounted() {
    // this.disableDevTools()
    // this.disableRightClick()
    // this.disableMediaSelect()
  },
  methods: {
    // 禁用F12和开发者工具快捷键
    disableDevTools() {
      document.addEventListener('keydown', (e) => {
        // F12
        if (e.key === 'F12') {
          e.preventDefault()
        }
        // Ctrl+Shift+I / Ctrl+Shift+J / Ctrl+Shift+C
        if (e.ctrlKey && e.shiftKey && (e.key === 'I' || e.key === 'J' || e.key === 'C')) {
          e.preventDefault()
        }
        // Ctrl+U (查看源码)
        if (e.ctrlKey && e.key === 'u') {
          e.preventDefault()
        }
      })
    },
    // 禁用右键菜单
    disableRightClick() {
      document.addEventListener('contextmenu', (e) => {
        e.preventDefault()
      })
    },
    // 禁止选中视频和图片，文字可以选择
    disableMediaSelect() {
      // 禁止拖拽
      document.addEventListener('dragstart', (e) => {
        if (e.target.tagName === 'IMG' || e.target.tagName === 'VIDEO') {
          e.preventDefault()
        }
      })
    }
  }
}
</script>

<style>
*{
  padding:0;
  margin: 0;
}
html, body, #app {
  height: 100%;
}
body {
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial, sans-serif;
  background-color: #f4f4f5;
  color: #18191c;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
button {
  font-family: inherit;
}

/* 禁止选中图片和视频 */
img, video {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  pointer-events: none;
}
/* 恢复视频的点击事件（用于播放控制） */
video {
  pointer-events: auto;
}
</style>
